import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#1A1412]/70 backdrop-blur-xl backdrop-saturate-150 border-b border-[#FDFBF7]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3" data-testid="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_indie-label-hub-2/artifacts/gvux7vc5_IMG_8054.jpeg" 
              alt="Vintage Ave Records"
              className="h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link 
              to="/roster" 
              className="text-[#FDFBF7] hover:text-[#D97736] transition-colors text-sm tracking-wide"
              data-testid="roster-link"
            >
              OUR TEAM
            </Link>
            <Link 
              to="/music" 
              className="text-[#FDFBF7] hover:text-[#D97736] transition-colors text-sm tracking-wide"
              data-testid="music-link"
            >
              MUSIC
            </Link>
            <Link 
              to="/news" 
              className="text-[#FDFBF7] hover:text-[#D97736] transition-colors text-sm tracking-wide"
              data-testid="news-link"
            >
              NEWS
            </Link>
            <Link 
              to="/shop" 
              className="text-[#FDFBF7] hover:text-[#D97736] transition-colors text-sm tracking-wide"
              data-testid="shop-link"
            >
              SHOP
            </Link>
            <Link 
              to="/submit" 
              className="text-[#FDFBF7] hover:text-[#D97736] transition-colors text-sm tracking-wide"
              data-testid="submit-link"
            >
              SUBMIT
            </Link>
            
            {user ? (
              <>
                <Link 
                  to={user.role === 'admin' ? '/admin' : '/dashboard'}
                  className="text-[#FDFBF7] hover:text-[#D97736] transition-colors text-sm tracking-wide"
                  data-testid="dashboard-link"
                >
                  {user.role === 'admin' ? 'ADMIN' : 'DASHBOARD'}
                </Link>
                <Button 
                  onClick={handleLogout}
                  variant="ghost"
                  className="text-[#FDFBF7] hover:text-[#D97736] hover:bg-transparent"
                  data-testid="logout-button"
                >
                  LOGOUT
                </Button>
              </>
            ) : (
              <Link to="/login">
                <Button 
                  className="bg-[#D97736] hover:bg-[#F08F4D] text-white rounded-full px-6"
                  data-testid="login-button"
                >
                  LOGIN
                </Button>
              </Link>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#FDFBF7] p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-[#2C221F] border-t border-[#3D302C]" data-testid="mobile-menu">
          <div className="px-4 py-6 space-y-4">
            <Link 
              to="/roster" 
              className="block text-[#FDFBF7] hover:text-[#D97736] py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              OUR TEAM
            </Link>
            <Link 
              to="/music" 
              className="block text-[#FDFBF7] hover:text-[#D97736] py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              MUSIC
            </Link>
            <Link 
              to="/news" 
              className="block text-[#FDFBF7] hover:text-[#D97736] py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              NEWS
            </Link>
            <Link 
              to="/shop" 
              className="block text-[#FDFBF7] hover:text-[#D97736] py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              SHOP
            </Link>
            <Link 
              to="/submit" 
              className="block text-[#FDFBF7] hover:text-[#D97736] py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              SUBMIT
            </Link>
            {user ? (
              <>
                <Link 
                  to={user.role === 'admin' ? '/admin' : '/dashboard'}
                  className="block text-[#FDFBF7] hover:text-[#D97736] py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {user.role === 'admin' ? 'ADMIN' : 'DASHBOARD'}
                </Link>
                <button
                  onClick={handleLogout}
                  className="block w-full text-left text-[#FDFBF7] hover:text-[#D97736] py-2"
                >
                  LOGOUT
                </button>
              </>
            ) : (
              <Link 
                to="/login"
                onClick={() => setMobileMenuOpen(false)}
              >
                <Button className="w-full bg-[#D97736] hover:bg-[#F08F4D] text-white rounded-full">
                  LOGIN
                </Button>
              </Link>
            )}
          </div>
        </div>
      )}
    </header>
  );
};